import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  MenuItem,
  Select,
} from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { FormControl } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  DASHBOARD_SPA_APPOINTMENTS_VIEW,
  DASHBOARD_SPA_VIEW,
  SPA,
  SPA_COUNTBOX_LIST,
  SPA_FILTER,
  SPA_STATUS,
} from '../../../../constants/DashboardConst';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { formatDate, getOrderCountsList } from '../../../../utils/dashboardUtils';
import {
  allSpaInfoSelector,
  dashboardSelectedSpaSelector,
  selectedHotelSelector,
  setDashboardSelectedSpa,
} from '../../../property/propertySlice';
import './DashboardSpaList.scss';
import { decryptLocalStorage } from '../../../../utils/authUtils';

const DashboardSpaList = (props) => {
  const history = useHistory();
  const {
    onViewToggle,
    allDashboardSpaList,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    currentFilterFromLocation,
  } = props;
  const [filterDataList, setFilterDataList] = useState([]);
  const [dashBoardSpaList, setDashBoardSpaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderCountList, setOrderCountList] = useState([]);
  const originalSpaList = useSelector(allSpaInfoSelector);
  const [selectedSpa, setSelectedSpa] = useState(useSelector(dashboardSelectedSpaSelector));
  const [tempSearchText, setTempSearchText] = useState('');
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };
  const dispatch = useDispatch();
  const selectedHotel = useSelector(selectedHotelSelector);

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onViewDetails = (order) => {
    onViewToggle(DASHBOARD_SPA_VIEW, true, order);
  };

  useEffect(() => {
    setLoading(false);
    setTempSearchText('');
    setDashBoardSpaList(getOrdersBySpa());
    setFilteredBaseList(getOrdersBySpa());
  }, [allDashboardSpaList, selectedSpa]);

  useEffect(() => {
    const updatedFilter = [...SPA_FILTER];
    updatedFilter[1]?.subMenu?.forEach((elm) => {
      elm.selected = false;
      return elm;
    });
    setFilterDataList(updatedFilter);
  }, []);

  useEffect(() => {
    setTempSearchText('');
    if (currentFilterFromLocation) {
      let subFilter = [...SPA_STATUS];
      switch (currentFilterFromLocation) {
        case 'ALL':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: false };
          });
          break;
        case 'NEW_REQUEST':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: x.id === 'New Request' };
          });
          break;
        case 'ARRIVING_TODAY':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: x.id === 'Arriving Today' };
          });
          break;
        case 'SCHEDULED':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: x.id === 'Scheduled' };
          });
          break;

        case 'GUEST_DECLINED':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: x.id === 'Cancelled' };
          });
          break;
        case 'COMPLETED':
          subFilter = SPA_STATUS.map((x) => {
            return { ...x, selected: x.id === 'Completed' };
          });
          break;

        default:
          break;
      }
      SPA_FILTER[1].subMenu = subFilter;
      setFilterDataList(SPA_FILTER);
      const ordersBySelectedSpa = getOrdersBySpa();
      const filteredItems = ordersBySelectedSpa.filter((item) => {
        return item?.status === currentFilterFromLocation;
      });
      onsetPage(0);
      setDashBoardSpaList(
        currentFilterFromLocation !== 'ALL' ? filteredItems : ordersBySelectedSpa,
      );
    }
  }, [currentFilterFromLocation]);

  const getOrdersBySpa = () => {
    let spaId = selectedSpa || allDashboardSpaList[0];
    const ordersBySelectedSpa = allDashboardSpaList.filter((obj) => obj.spaId === spaId?.id);
    // const ordersBySelectedSpa = allDashboardSpaList;
    setOrderCountList(getOrderCountsList(SPA_COUNTBOX_LIST, ordersBySelectedSpa));
    return ordersBySelectedSpa;
  };

  useEffect(() => {
    setSelectedSpa(null);
    dispatch(setDashboardSelectedSpa(null));
  }, [selectedHotel, dispatch]);

  useEffect(() => {
    if (originalSpaList.length) {
      const newSelectedSpa = originalSpaList.find((spa) => spa.id === decryptLocalStorage('spaId'));
      setSelectedSpa(newSelectedSpa ?? originalSpaList[0]);
      dispatch(setDashboardSelectedSpa(newSelectedSpa ?? originalSpaList[0]));
    }
  }, [originalSpaList?.length, dispatch]);

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    onsetPage(0);
    if (!searchText) {
      setDashBoardSpaList(filteredBaseList);
      return;
    }
    const filteredRows = filteredBaseList?.filter((item) => {
      return (
        item.guestName?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.id?.includes(searchText)
      );
    });
    setDashBoardSpaList(filteredRows);
  };

  const filteredRecords = (filters, field) => {
    const ordersBySelectedSpa = getOrdersBySpa();

    if (field === 'all') {
      setFilteredBaseList(ordersBySelectedSpa);
      setDashBoardSpaList(ordersBySelectedSpa);
      SPA_FILTER[1].subMenu = SPA_STATUS;
      setFilterDataList(SPA_FILTER);
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredItems = ordersBySelectedSpa.filter((item) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(item['orderStatus']),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredItems);
      setDashBoardSpaList(filteredItems);
    }
  };

  const handleSpaChange = (e) => {
    if (originalSpaList.length > 0) {
      const newSelectedSpa = originalSpaList.find((spa) => spa.id === e.target.value);
      setSelectedSpa(newSelectedSpa);
      dispatch(setDashboardSelectedSpa(newSelectedSpa));
    }
  };

  const isCurrentSelectedTile = (status) => {
    switch (status) {
      case 'ALL':
        return filterDataList[1]?.subMenu?.every((v) => v.selected === false);
      case 'NEW_REQUEST':
        return filterDataList[1]?.subMenu?.find((x) => x.id === 'New Request' && x.selected);
      case 'ARRIVING_TODAY':
        return filterDataList[1]?.subMenu?.find((x) => x.id === 'Arriving Today' && x.selected);
      case 'SCHEDULED':
        return filterDataList[1]?.subMenu?.find((x) => x.id === 'Scheduled' && x.selected);

      case 'GUEST_DECLINED':
        return filterDataList[1]?.subMenu?.find((x) => x.id === 'Cancelled' && x.selected);

      case 'COMPLETED':
        return filterDataList[1]?.subMenu?.find((x) => x.id === 'Completed' && x.selected);

      default:
        break;
    }
  };
  return (
    <div className='container px-2 py-2 mw-100'>
      <div className='dashboard-spa-list'>
        <div className='d-flex gap-2 flex-wrap pb-2 justify-content-end'>
          <div className='d-flex gap-2 flex-wrap justify-content-start position-relative col'>
            {originalSpaList?.length > 0 && (
              <Button
                className='py-2 dropdown-button'
                variant='outlined'
                color='secondary'
                size='medium'
              >
                <FormControl variant='standard' sx={{ mx: 1, minWidth: 240 }}>
                  <Select
                    labelId='spalist-label'
                    id='spa-select-standard'
                    value={selectedSpa?.id || decryptLocalStorage('spaId')}
                    onChange={(e) => handleSpaChange(e)}
                    label='Select Spa'
                    MenuProps={{ className: 'spa-list-dropdown' }}
                  >
                    {originalSpaList?.map((spaItem) => (
                      <MenuItem key={spaItem?.id} value={spaItem?.id}>
                        {spaItem?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Button>
            )}
          </div>
          <div className='d-flex gap-2 flex-wrap'>
            <Button
              className='py-2'
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<ArrowRightIcon />}
              onClick={() => history.push('/spa?tab=TREATMENTS')}
            >
              {'Treatments'}
            </Button>
            <Button
              className='py-2'
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<ArrowRightIcon />}
              onClick={() => onViewToggle(DASHBOARD_SPA_APPOINTMENTS_VIEW, true, null)}
            >
              Appointments
            </Button>
          </div>
        </div>

        {orderCountList?.length > 0 && (
          <div>
            <div className='py-2 d-flex flex-wrap gap-3'>
              {orderCountList?.map((orderCategory, orderCategoryIndex) => (
                <CustomCountBox key={orderCategoryIndex} count={orderCategory} className='col' />
              ))}
            </div>
          </div>
        )}

        <div className='card shadow'>
          <div className='px-2 py-2 group-list-container'>
            <SearchBar
              displayAddOrEdit='hide'
              setSearchText={setSearchText}
              filterList={filterDataList}
              setFilterDataList={setFilterDataList}
              filteredRecoard={filteredRecords}
              searchText={tempSearchText}
              setSearch={setTempSearchText}
              actionMenuItems={[]}
            />
            <div className='row p-2 d-flex'>
              {loading ? (
                <div className='pt-2 col-md-12'>
                  <LinearProgressBar />
                </div>
              ) : (
                dashBoardSpaList && (
                  <TableContainer>
                    <Table className='list-table' aria-label='simple table'>
                      <TableHead>
                        <TableRow className='border-white pointer'>
                          <TableCell className='w-15'>Booking Date & Time</TableCell>
                          <TableCell className='w-15' align='center'>
                            Guest name
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Guest type
                          </TableCell>
                          <TableCell className='w-20' align='center'>
                            Reservation Date & Time
                          </TableCell>
                          <TableCell className='w-10' align='center'>
                            No of Guests
                          </TableCell>
                          <TableCell className='w-10' align='center'>
                            Channel Type
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? dashBoardSpaList.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : dashBoardSpaList
                        ).map((item, i) => (
                          <TableRow
                            key={i}
                            className='border-white pointer'
                            onClick={(e) => {
                              onViewDetails(item, e);
                            }}
                          >
                            <TableCell align='left'>
                              {formatDate(item?.bookingTime, 'DD MMM, hh:mm a')}
                            </TableCell>
                            <TableCell align='center'>{item.guestName}</TableCell>
                            <TableCell align='center'>
                              {item?.guestType === 'resident'
                                ? `Resident - Room ${item?.roomNo === '' ? '---' : item?.roomNo}`
                                : 'Non Resident'}
                            </TableCell>
                            <TableCell align='center'>
                              {formatDate(item?.scheduledDate, 'DD MMM, hh:mm a')}
                            </TableCell>
                            <TableCell align='center'>{item.numberOfGuest}</TableCell>
                            <TableCell align='center'>{item.channelType || '---'}</TableCell>
                            <TableCell align='center'>
                              <div className='d-flex align-content-center px-2'>
                                <div
                                  className={
                                    item.statusClass +
                                    ' pill d-flex justify-content-center align-items-center py-2 w-90'
                                  }
                                >
                                  <span className='ms-1'>{item.orderStatus ?? 'NA'}</span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow className='paginator'>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            count={dashBoardSpaList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSpaList;
